globalThis["__sentryRewritesTunnelPath__"] = "/monitoring";
globalThis["SENTRY_RELEASE"] = {"id":"2d062b607ab70ac5e3e429254bfea8f8e5e6f3c9"};
globalThis["__sentryBasePath"] = undefined;
globalThis["__rewriteFramesAssetPrefixPath__"] = "";
import * as Sentry from '@sentry/nextjs';

Sentry.init({
  enabled: process.env.NODE_ENV === 'production',

  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NODE_ENV,

  sampleRate: 0.1,
  tracesSampleRate: 0, // Disable performance monitoring

  debug: false,

  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,

  integrations: [],
});
